<template>
  <div class="candidate column">
    <Header />
    <Button layout="back" @click="router.push('/supporter/candidaturas')" class="show-s">
      <i class="fa fa-arrow-left"></i> Jobs
    </Button>
    <div class="content">
      <Candidate />
    </div>
    <Status />
    <Telegram />
  </div>
</template>

<script>
import Header from "@/components/HeaderSupporter.vue";
import Candidate from "@/components/Candidate.vue";
import Button from "@/components/Button.vue";
import Router from "@/router";
import Status from "@/components/Status.vue";
import Telegram from "@/components/Telegram.vue";

export default {
  name: "JobView",
  components: {
    Header,
    Candidate,
    Button,
    Status,
    Telegram,
  },
  data() {
    return {
      router: Router,
    };
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.candidate {
  .content {
    padding: 42px 35px;
    @media (max-width: $small) {
      padding: 7px;
    }
  }
}
</style>
